import React from 'react'
import { Link } from 'react-router-dom'

const NewProjects = () => {
    return (
        <>

            <section class="banner-area over-layer-black">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="page-title-box" style={{marginTop:"40px"}}>
                                <h2>New Projects</h2>
                                <p><Link to="/"><a>Home</a></Link> / Project Details </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="property-single-pages bg-f8" style={{marginTop:"40px"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 col-md-8">
                            <div className="property-box">
                                <div id="carousel-example-generic" className="carousel slide" data-ride="carousel">
                                    <ol className="carousel-indicators">
                                        <li data-target="#carousel-example-generic" data-slide-to={0} className="active">
                                            <img src=" /assets/images/Gallery_5.png" alt="Property Image" />
                                        </li>
                                        <li data-target="#carousel-example-generic" data-slide-to={1}>
                                            <img src=" /assets/images/Gallery_6.png" alt="Property Image" />
                                        </li>
                                        <li data-target="#carousel-example-generic" data-slide-to={2}>
                                            <img src=" /assets/images/Gallery_3.png" alt="Property Image" />
                                        </li>
                                        <li data-target="#carousel-example-generic" data-slide-to={3}>
                                            <img src=" /assets/images/Gallery_2.png" alt="Property Image" />
                                        </li>
                                        <li data-target="#carousel-example-generic" data-slide-to={4}>
                                            <img src=" /assets/images/Gallery_4.png" alt="Property Image" />
                                        </li>
                                    </ol>
                                    <div className="carousel-inner style-2" role="listbox">
                                        <div className="item active">
                                            <img src=" /assets/images/Gallery_5.png" alt />
                                        </div>
                                        <div className="item">
                                            <img src=" /assets/images/Gallery_6.png" alt />
                                        </div>
                                        <div className="item">
                                            <img src=" /assets/images/Gallery_3.png" alt />
                                        </div>
                                        <div className="item">
                                            <img src=" /assets/images/Gallery_2.png" alt />
                                        </div>
                                        <div className="item">
                                            <img src=" /assets/images/Gallery_4.png" alt />
                                        </div>
                                    </div>
                                    <a className="left carousel-control" href="#carousel-example-generic" role="button" data-slide="prev">
                                        <span className="glyphicon glyphicon-chevron-left" aria-hidden="true" />
                                        <span className="sr-only">Previous</span>
                                    </a>
                                    <a className="right carousel-control" href="#carousel-example-generic" role="button" data-slide="next">
                                        <span className="glyphicon glyphicon-chevron-right" aria-hidden="true" />
                                        <span className="sr-only">Next</span>
                                    </a>
                                </div>
                                <div className="property-content">
                                    <h4 style={{color:"black"}}><a ><b>Description</b></a></h4>
                                    {/* <p>LORVEN COUNTY located on Mumbai Highway @ Arur We are very glad to inform you that we successfully completed the project and started its extensions on customers demandhat we are sold 80% plots in our own prestigious project.</p> */}
                                    <p>Welcome to Greenville Projects Pvt. Ltd. After successful completion of our three projects LORVEN COUNTY Phase - 1, 2 & 3. Now we are presenting with Pride, our new premium project LORVEN PRIDE. A prestigious highway facing project offering a perfect plot in a thriving community. LORVEN PRIDE Offers you the best premium commercial, semi commercial and residential villa plots. Invest in LORVEN PRIDE to shape your future.</p>
                                    {/* <div className="condation">
                                        <h4><u>Condation</u></h4>
                                        <div className="condation-box">
                                            <ul>
                                                <li><i className="cl-sen flaticon-map" />Area 165 Sqyards</li>
                                            </ul>
                                        </div>
                                    </div> */}
                                    <div className="condation" style={{marginTop:"20px"}}>
                                    <h4 style={{color:"black"}}><a ><b>PROJECT HIGHLIGHTS</b></a></h4>
                                        <div className="condation-box">
                                            <ul>
                                                <li className='AmititiesContainer'>
                                                    <div className='iconimgcon'>
                                                        <img src="\assets\images\ROADS.png" alt className={'iconimage'} style={{ height:"60px", width:"70px" }} />
                                                    </div>
                                                    <div>
                                                        {/* <p className='iconText'>Banquet hall</p> */}
                                                        <p className='iconText'>200' & 33' CC ROADS</p>
                                                    </div>
                                                </li>
                                                <li className='AmititiesContainer '>
                                                    <div>
                                                        <img src="\assets\images\icons\ic\Jogging track.png" alt className={"iconimage"} />
                                                    </div>
                                                    <div>
                                                        {/* <p className='iconText'>Yoga/Meditation center</p> */}
                                                        <p className='iconText'>Underground Waterpipe Line </p>
                                                    </div>
                                                </li>
                                                <li className='AmititiesContainer'>
                                                    <div>
                                                        <img src="\assets\images\Underground Electricity.png" alt className={"iconimage"} style={{ height:"60px", width:"70px" }} />
                                                    </div>
                                                    <div>
                                                        {/* <p className='iconText'>Party lawn</p> */}
                                                        <p className='iconText'>Electricity </p>
                                                    </div>
                                                </li>
                                                <li className='AmititiesContainer'>
                                                    <div>
                                                        <img src="\assets\images\Underground Drainage System.jpg" alt className={"iconimage"} style={{ height:"40px", width:"50px" }} />
                                                    </div>
                                                    <div>
                                                        {/* <p className='iconText'>100 Ft.paver road</p> */}
                                                        <p className='iconText'>Underground Drainage System</p>
                                                    </div>
                                                </li>

                                                <li className='AmititiesContainer'>
                                                    <div>
                                                        <img src="\assets\images\icons\ic\UG sump and OHT .png" alt className={"iconimage"} />
                                                    </div>
                                                    <div>
                                                        {/* <p className='iconText'>UG sump and OHT</p> */}
                                                        <p className='iconText'>Beautiful Landscaping</p>
                                                    </div>
                                                </li>


                                                <li className='AmititiesContainer'>
                                                    <div>
                                                        <img src="\assets\images\icons\ic\Alluring landscapes.png" alt className={"iconimage"} />
                                                    </div>
                                                    <div>
                                                        {/* <p className='iconText'>Alluring landscapes</p> */}
                                                        <p className='iconText'>Street Lights</p>
                                                    </div>
                                                </li>


                                                <li className='AmititiesContainer'>
                                                    <div>
                                                        <img src="\assets\images\icons\ic\Jogging track.png" alt className={"iconimage"} />
                                                    </div>
                                                    <div>
                                                        {/* <p className='iconText'>Jogging track</p> */}
                                                        <p className='iconText'>Vaastu Complient</p>
                                                    </div>
                                                </li>


                                                <li className='AmititiesContainer'>
                                                    <div>
                                                        <img src="\assets\images\icons\ic\paver. entrance  plots.png" alt className={"iconimage"} />
                                                    </div>
                                                    <div>
                                                        {/* <p className='iconText'>Paver entrance for plots</p> */}
                                                        <p className='iconText'>Avenue Planitation</p>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                        <div className="col-sm-12 col-md-4">
                            <div className="blog-sideber pt-3 pb-3">
                                {/* <div className="widget clearfix">
                                    <div className="blog-search">
                                        <form  className="clearfix">
                                            <input type="search" placeholder="Search Here.." />
                                            <button type="submit">
                                                <span className="pe-7s-search" />
                                            </button>
                                        </form>
                                    </div>
                                </div> */}
                                <div className="widget clearfix">
                                    <div className="sideber-title">
                                        <h4>Recent Propertys</h4>
                                    </div>
                                    <div className="widget-post">
                                        <div className="news-area clearfix">
                                            <div className="news-img">
                                                <a >
                                                    <img src="/assets/images/Gallery_5.png" alt />
                                                    <span className="fa fa-link" />
                                                </a>
                                            </div>

                                        </div>
                                        <div className="news-area clearfix">
                                            <div className="news-img">
                                                <a >
                                                    <img src="/assets/images/Gallery_6.png" alt />
                                                    <span className="fa fa-link" />
                                                </a>
                                            </div>

                                        </div>
                                        <div className="news-area clearfix">
                                            <div className="news-img">
                                                <a >
                                                    <img src="/assets/images/Gallery_3.png" alt />
                                                    <span className="fa fa-link" />
                                                </a>
                                            </div>

                                        </div>
                                        <div className="news-area clearfix">
                                            <div className="news-img">
                                                <a >
                                                    <img src="/assets/images/Gallery_2.png" alt />
                                                    <span className="fa fa-link" />
                                                </a>
                                            </div>

                                        </div>
                                        {/* <div className="news-area clearfix">
                                            <div className="news-img">
                                                <a >
                                                    <img src="/assets/images/Gallery_4.png" alt />
                                                    <span className="fa fa-link" />
                                                </a>
                                            </div>

                                        </div> */}
                                    </div>
                                </div>
                                {/* <div className="widget clearfix">
                                    <div className="sideber-title">
                                        <h4>Fliker Feed</h4>
                                    </div>
                                    <div className="flicker-feed gutter">
                                        <a className="lightbox-image" ><img src="/assets/images/greenville5.jpg" alt className='img1' /> </a>
                                        <a className="lightbox-image" ><img src="/assets/images/greenville6.jpg" alt className='img1' /> </a>
                                        <a className="lightbox-image" ><img src="/assets/images/greenville7.jpg" alt className='img1' /> </a>
                                        <a className="lightbox-image" ><img src="/assets/images/greenville8.jpg" alt className='img1' /> </a>
                                        <a className="lightbox-image" > <img src="/assets/images/greenville9.jpg" alt className='img1' /> </a>
                                        <a className="lightbox-image" > <img src="/assets/images/greenville10.jpg" alt className='img1' /> </a>
                                        <a className="lightbox-image" > <img src="/assets/images/greenville11.jpg" alt className='img1' /> </a>
                                        <a className="lightbox-image" > <img src="/assets/images/greenville12.jpg" alt className='img1' /> </a>
                                        <a className="lightbox-image" ><img src="/assets/images/greenville13.jpg" alt className='img1' /> </a>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="portfolio-area " 
            // style={{marginTop:'-10%'}}
            >
                <div className="container">
                    <h3 style={{ display: 'flex', justifyContent: 'center', marginTop:"20px" }}><u >Layout    </u></h3>
                    <div className="row">
                        <div className="col-12 col-md-12">
                            <div className="portfolio-content mt-3" >
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <div style={{ width: '750px', textAlign: 'center' }}><p >Invest in a space that promises growth and tranquility. Unmatched Location, Unlimited Potential</p></div>
                                </div>
                                <div className="row mt-3 " >
                                    <div className="col-sm-12 col-md-12" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                        <div className="col-sm-10 col-md-10">
                                            <div className="hover-box">
                                                <img src="\assets\images\LOCATION MAP.jpg" alt />
                                                <div className="hover-layer" style={{ opacity: 0.3 }} />
                                                <div className="hover-box-content">
                                                    <a ><i className="fa fa-arrows" aria-hidden="true" /></a>
                                                    <a ><i className="fa fa-link" aria-hidden="true" /></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-12" >
                                            <div class=" container download-brocher bounceIn animated abc2 col-sm-11 col-md-11" style={{ paddingTop: '28px' }} >
                                                <a href='\assets\images\Green Ville Final flyer -24-07-25.pdf' target='_blank' download id='abc'>Download Brochure</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                               
                            </div>
                        </div>
                    </div>
                </div>
            </section>








        </>
    )
}

export default NewProjects